import { ReactNode } from 'react';
import { MountTransition } from '@/components/MonitoringPanel/components/MountTransition';
import { Modal } from '@simplywallst/ui-core';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';
import { SidePanelAnimation } from './styled';

type Props = {
  onClose: () => void;
  children?: ReactNode;
};

export const SidePanel = ({ onClose, children }: Props) => {
  const ANIMATION_DURATION = 300;

  return (
    <MountTransition onExited={onClose} duration={ANIMATION_DURATION}>
      {({ state, exit }) => {
        const isOpen = state === 'entering' || state === 'entered';
        return (
          <Modal isNaked={true}>
            <SidePanelAnimation
              className="absolute inset-0 left-auto w-full max-w-[420px] bg-p-grey-180 pb-[calc(16px+env(safe-area-inset-top))]"
              isOpen={isOpen}
              duration={ANIMATION_DURATION}
            >
              <div className="bg-p-grey-180">
                <div
                  className="fixed top-0 z-10 grid h-x7 w-full max-w-[420px] grid-cols-[max-content_max-content] items-center justify-between bg-p-grey-180 px-x2 pt-[calc(16px+env(safe-area-inset-top))]"
                  aria-label="close"
                >
                  <div className="text-lg text-softer">Last 30d updates</div>
                  <button type="button" onClick={exit} aria-label="close">
                    <CrossSolid fill="darkGray" />
                  </button>
                </div>
                <div className="mt-x7 grid gap-x1 overflow-y-auto bg-p-grey-180 lg:mx-x2">
                  {children}
                </div>
              </div>
            </SidePanelAnimation>
          </Modal>
        );
      }}
    </MountTransition>
  );
};
